import { lazy } from 'react';

export const LandingMainAsync = lazy(() => import('./landing-main'));
